module.exports = __webpack_public_path__ + "static/media/instalment.4d8e7244.png";